module.exports = "/img/createIssue.140bb5ba.gif";